// extracted by mini-css-extract-plugin
module.exports = {"btn":"_2IMJpv1X3godP4UGswjJ5W"};